// Watch list carried over from the previous site.
export const tvShows = [
  {
    title: "Breaking Bad",
    genre: "Drama/Crime",
    rating: "9.5/10",
    review: "A masterpiece that explores the transformation of a mild-mannered chemistry teacher into a ruthless drug kingpin."
  },
  {
    title: "The Wire",
    genre: "Drama/Crime",
    rating: "9.3/10",
    review: "A complex, realistic portrayal of Baltimore's drug scene, law enforcement, and institutions."
  },
  {
    title: "Black Mirror",
    genre: "Sci-Fi/Thriller",
    rating: "8.8/10",
    review: "Thought-provoking anthology series exploring the dark side of technology and its impact on society."
  },
  {
    title: "Succession",
    genre: "Drama/Comedy",
    rating: "9.0/10",
    review: "A captivating portrayal of family dynamics within a powerful media empire, with sharp dialogue and character development."
  },
  {
    title: "Mr. Robot",
    genre: "Drama/Thriller",
    rating: "8.7/10",
    review: "A compelling psychological thriller about a cybersecurity engineer with social anxiety who becomes entangled in a hacking conspiracy."
  },
  {
    title: "Dark",
    genre: "Sci-Fi/Mystery",
    rating: "8.9/10",
    review: "A mind-bending German series exploring time travel, family secrets, and interconnected lives across generations."
  },
  {
    title: "The Big Bang Theory",
    genre: "Comedy/Sitcom",
    rating: "8.6/10",
    review: "A hilarious sitcom about a group of brilliant but socially awkward physicists and their interactions with the wider world."
  }
];

export const animeShows = [
  {
    title: "Dragon Ball Z",
    genre: "Action/Adventure",
    rating: "9.2/10",
    review: "Vegeta training in the gravity chamber while everyone else performs at the tournament. The prince who works alone."
  },
  {
    title: "Death Note",
    genre: "Psychological/Thriller",
    rating: "9.5/10",
    review: "L solving the case alone in a dark room. No performance. Just the work. The real protagonist."
  },
  {
    title: "Code Geass",
    genre: "Mecha/Drama",
    rating: "9.1/10",
    review: "A gripping tale of rebellion, politics, and moral ambiguity with one of anime's most compelling protagonists."
  },
  {
    title: "Spirited Away",
    genre: "Fantasy/Adventure",
    rating: "9.6/10",
    review: "A breathtaking masterpiece about a young girl navigating a spirit world to save her parents."
  },
  {
    title: "Demon Slayer",
    genre: "Action/Supernatural",
    rating: "9.0/10",
    review: "A visually stunning journey following Tanjiro's quest to cure his sister and avenge his family."
  },
  {
    title: "Attack on Titan",
    genre: "Dark Fantasy/Action",
    rating: "9.4/10",
    review: "A brutal, complex narrative about humanity's struggle against gigantic humanoids, with unprecedented plot twists."
  },
  {
    title: "Fullmetal Alchemist: Brotherhood",
    genre: "Adventure/Fantasy",
    rating: "9.7/10",
    review: "A perfectly crafted story about two brothers seeking to restore their bodies after a failed alchemical experiment."
  },
  {
    title: "Steins;Gate",
    genre: "Sci-Fi/Thriller",
    rating: "9.3/10",
    review: "A time travel narrative that evolves from light-hearted to intensely dramatic with complex scientific concepts."
  },
  {
    title: "Hunter x Hunter",
    genre: "Adventure/Fantasy",
    rating: "9.5/10",
    review: "A coming-of-age story that subverts shonen tropes with exceptional character development and complex power systems."
  },
  {
    title: "Neon Genesis Evangelion",
    genre: "Mecha/Psychological",
    rating: "9.2/10",
    review: "A groundbreaking psychological exploration disguised as a mecha anime, delving into depression and human connection."
  },
  {
    title: "My Hero Academia",
    genre: "Superhero/Action",
    rating: "8.9/10",
    review: "In a world where 80% of people have powers, a powerless boy pursues his dream of becoming a hero."
  },
  {
    title: "One Punch Man",
    genre: "Action/Comedy",
    rating: "9.0/10",
    review: "A brilliant satire of superhero tropes featuring a protagonist who defeats any enemy with a single punch."
  },
  {
    title: "Cowboy Bebop",
    genre: "Space Western/Noir",
    rating: "9.3/10",
    review: "A stylish space western following bounty hunters with haunted pasts, set to an iconic jazz soundtrack."
  },
  {
    title: "Naruto",
    genre: "Action/Adventure",
    rating: "8.8/10",
    review: "Itachi running the long game while everyone else reacts. The one who saw the whole board."
  },
  {
    title: "Your Lie in April",
    genre: "Drama/Music",
    rating: "9.0/10",
    review: "A heartbreaking story about a piano prodigy who rediscovers music and emotion through a free-spirited violinist."
  },
  {
    title: "Vinland Saga",
    genre: "Historical/Action",
    rating: "9.1/10",
    review: "Thorfinn building a farm. The arc from violence to quiet construction. What comes after revenge."
  }
];

export const movies = [
  {
    title: "Interstellar",
    genre: "Sci-Fi/Drama",
    rating: "9.4/10",
    review: "A breathtaking exploration of space travel, time dilation, and the transcendent power of love across dimensions."
  },
  {
    title: "The Martian",
    genre: "Sci-Fi/Adventure",
    rating: "9.0/10",
    review: "A gripping survival story about an astronaut stranded on Mars who uses science and wit to stay alive."
  },
  {
    title: "Black Swan",
    genre: "Psychological/Thriller",
    rating: "8.9/10",
    review: "A haunting descent into the psyche of a ballet dancer whose pursuit of perfection drives her to madness."
  },
  {
    title: "Whiplash",
    genre: "Drama/Music",
    rating: "9.3/10",
    review: "An intense portrayal of a young drummer and his abusive instructor, exploring the cost of artistic greatness."
  },
  {
    title: "Rockstar",
    genre: "Drama/Music",
    rating: "8.8/10",
    review: "A Bollywood masterpiece about a musician whose heartbreak fuels his artistic journey and eventual self-destruction."
  },
  {
    title: "A Star Is Born",
    genre: "Drama/Music",
    rating: "8.7/10",
    review: "A poignant romance between a fading musical star and a talented newcomer, exploring fame, addiction, and sacrifice."
  },
  {
    title: "The Shawshank Redemption",
    genre: "Drama",
    rating: "9.7/10",
    review: "A profound tale of hope, friendship, and redemption set in a prison, widely regarded as one of the greatest films ever made."
  },
  {
    title: "Forrest Gump",
    genre: "Drama/Comedy",
    rating: "9.3/10",
    review: "The extraordinary journey of a simple man who unwittingly influences several defining events in U.S. history."
  },
  {
    title: "The Man Who Knew Infinity",
    genre: "Biography/Drama",
    rating: "8.6/10",
    review: "The moving story of Indian mathematician Srinivasa Ramanujan and his friendship with his professor at Cambridge."
  },
  {
    title: "The Pursuit of Happyness",
    genre: "Biography/Drama",
    rating: "8.8/10",
    review: "A powerful true story of a struggling salesman who rises from homelessness to build a better life for his son."
  },
  {
    title: "Good Will Hunting",
    genre: "Drama",
    rating: "9.2/10",
    review: "A janitor with extraordinary mathematical abilities navigates life, love, and therapy in this deeply human story."
  },
  {
    title: "The Theory of Everything",
    genre: "Biography/Drama",
    rating: "8.7/10",
    review: "The inspiring story of physicist Stephen Hawking and his relationship with Jane Wilde as he faces a debilitating disease."
  }
];
